<template>
  <div>
    <div
      v-if="searchable"
      class="is-flex is-justify-content-space-between is-align-content-center my-5"
    >
      <div class="is-flex mp-search-input-wrapper">
        <b-tooltip
          type="is-tooltip"
          position="is-bottom"
          :triggers="['click']"
          :auto-close="['outside', 'escape']"
        >
          <template v-slot:content>
            <label>
              <!-- {{ "Keresni a következő kifejezéssel lehetséges: mezőnév == érték" }} -->
              {{ $t("pp:list.search.help.label1") }} </label
            ><br />
            <label>
              <!-- {{ "Például: name == InstaCash" }} -->
              {{ $t("pp:list.search.help.label2") }}
            </label>
            <br />
            <br />
            <label>
              <!-- {{ 'Kifejezéseket össze lehet fűzni "&&"-el' }} -->
              {{ $t("pp:list.search.help.label3") }}a
            </label>
            <br />
            <label>
              <!-- {{ "Például: phoneNumber == 123 && email == gmail.com" }} -->
              {{ $t("pp:list.search.help.label4") }}
            </label>
            <span v-if="searchFields">
              <br /><br />
              <label>
                <!-- {{ "Kereshető mezőnevek: " }} -->
                {{ $t("pp:list.search.help.label5") }}
              </label>

              <span v-for="(item, index) in searchFields" :key="index">
                <br /><label>{{
                  `- ${$t(item.name)}: ${item.identifier} ${
                    item.genericSearch ? "*" : ""
                  }`
                }}</label>
              </span>

              <br /><br />

              <label>
                <!-- * Ha a kereső mezőben nem szerepel kifejezés, <br />
                akkor a csillagal jelölt mezőkben történik a keresés -->
                {{ $t("pp:list.search.help.label6") }}
              </label>
            </span>
          </template>
          <b-icon
            class="search-tooltip-icon"
            icon-pack="fa"
            icon="info-circle"
            type="is-info"
            size="is-small"
          ></b-icon>
        </b-tooltip>
        <b-input
          :placeholder="$t('pp:list.search.placeholder')"
          type="search"
          icon="search"
          icon-clickable
          class="mp-search-input"
          @keydown.native.enter.prevent="search"
          v-model="searchInput"
        >
        </b-input>
      </div>

      <div>
        <slot name="next-to-search" />
      </div>

      <div class="ml-auto">
        <slot></slot>
      </div>
    </div>

    <div v-else style="margin-bottom: 15px">
      <slot></slot>
      <br style="clear: both" />
    </div>

    <slot name="under-search" />

    <div v-if="searchFields" class="mb-5">
      <b-collapse class="card" animation="slide" :open="false">
        <template #trigger="props">
          <div class="card-header" role="button" :aria-expanded="props.open">
            <div class="card-header-title is-flex has-gap-1">
              <div>
                {{ $t("pp:list.detailed_search.search") }}
              </div>
              <div class="search-component-info">
                <b-tooltip
                  :label="$t('pp.list.detailed_search.search.tooltip')"
                  type="is-info"
                  position="is-bottom"
                  multilined
                >
                  <b-icon
                    class="search-tooltip-icon"
                    icon-pack="fa"
                    icon="info-circle"
                    type="is-info"
                    size="is-small"
                  ></b-icon>
                </b-tooltip>
              </div>
            </div>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'chevron-up' : 'chevron-down'">
              </b-icon>
            </a>
          </div>
        </template>

        <div class="card-content">
          <div class="content searchComponent">
            <div
              v-if="Object.keys(searchObject).length"
              style="
                display: grid;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                grid-gap: 12px;
                align-items: end;
              "
            >
              <div v-for="(item, index) in searchFields" :key="index">
                <template
                  v-if="
                    item.type === SEARCH_FIELD_TYPES.DATETIME ||
                    item.type === SEARCH_FIELD_TYPES.DATE
                  "
                >
                  <div class="is-flex has-gap-2 is-align-items-end">
                    <b-field
                      style="margin-bottom: 0"
                      :label="$t(item.name) + ' (tól)'"
                    >
                      <b-datetimepicker
                        v-model="searchObject[item.identifier][0]"
                      >
                        <template #right>
                          <b-button
                            label="Clear"
                            type="is-danger"
                            icon-left="close-circle"
                            outlined
                            @click="deleteSearchValue(item.identifier, 0)"
                          />
                        </template>
                      </b-datetimepicker>
                    </b-field>

                    <b-field :label="$t(item.name) + ' (ig)'">
                      <b-datetimepicker
                        v-model="searchObject[item.identifier][1]"
                      >
                        <template #right>
                          <b-button
                            label="Clear"
                            type="is-danger"
                            icon-left="close-circle"
                            outlined
                            @click="deleteSearchValue(item.identifier, 0)"
                          />
                        </template>
                      </b-datetimepicker>
                    </b-field>
                  </div>
                </template>

                <template v-else-if="item.type === SEARCH_FIELD_TYPES.ENUM">
                  <b-field :label="$t(item.name) + ''" expanded>
                    <b-select
                      expanded
                      multiple
                      native-size="2"
                      size="is-small"
                      v-model="searchObject[item.identifier]"
                    >
                      <option
                        v-for="(enumValue, key, index) in item.values"
                        :key="index"
                        :value="key"
                      >
                        {{ $t(enumValue) }}
                      </option>
                    </b-select>
                  </b-field>
                </template>

                <template v-else-if="item.type === SEARCH_FIELD_TYPES.BOOLEAN">
                  <b-field :label="$t(item.name)" expanded>
                    <b-select
                      expanded
                      size="is-small"
                      v-model="searchObject[item.identifier]"
                    >
                      <option value="true">Igen</option>
                      <option value="false">Nem</option>
                    </b-select>
                  </b-field>
                </template>

                <template v-else>
                  <b-field :label="$t(item.name) + ''" expanded>
                    <b-input v-model="searchObject[item.identifier]" />
                  </b-field>
                </template>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer is-flex has-gap-2 px-3 py-3">
          <b-button type="is-blue" @click="searchWithComponent">{{
            $t("pp:list.search.placeholder")
          }}</b-button>
          <b-button type="is-blue" @click="resetSearchObject(true)">{{
            $t("pp:list.detailed_search.empty_fields")
          }}</b-button>
        </footer>
      </b-collapse>
    </div>

    <b-table
      :data="rows"
      :paginated="!paginated"
      :per-page="20"
      :current-page="1"
      :hoverable="true"
      :height="height"
      :sticky-header="stickyHeader"
      :backend-sorting="backendSorting"
      :default-sort="initialSortField"
      :default-sort-direction="initialSortOrder"
      scrollable
      @sort="onSort"
      ref="table"
      :detailed="detailed"
      detail-key="id"
      detail-transition="fade"
      :show-detail-icon="false"
      :loading="loading || internalLoading"
    >
      <b-table-column
        v-if="image"
        field=""
        label=""
        v-slot="props"
        sort-icon="arrow-up"
        sort-icon-size="is-small"
        width="64"
      >
        <image-loader
          :id="props.row[imageKey]"
          max-width="64px"
          min-width="64px"
        >
        </image-loader>
      </b-table-column>

      <b-table-column
        v-for="col in columns"
        :key="col.field"
        :field="col.field"
        :label="$t(col.label)"
        v-slot="props"
        :sortable="col.sortable === undefined ? true : col.sortable"
        sort-icon="arrow-up"
        sort-icon-size="is-small"
        :width="col.width"
      >
        <span v-if="col.vhtml" v-html="col.format(props.row)"></span>
        <span
          v-else
          :style="{
            display: 'block',
            overflow: 'hidden',
            maxWidth: col.maxWidth,
            minWidth: col.minWidth,
          }"
          >{{ col.format(props.row) }}</span
        >
      </b-table-column>

      <b-table-column
        v-for="cc in customColumns"
        :field="cc.field"
        :custom-key="cc.field"
        :label="$t(cc.label)"
        :key="cc.label"
        v-slot="props"
      >
        <component
          :is="cc.component"
          :row="props.row"
          @select="cc.onSelect"
        ></component>
      </b-table-column>

      <!--Action custom column-->
      <b-table-column
        field="edit"
        custom-key="edit"
        v-slot="props"
        numeric
        sticky
        v-if="actions"
      >
        <span class="action-column">
          <span
            v-for="action in actions"
            :key="action.icon"
            @click="action.function(props.row, $event)"
          >
            <b-icon
              v-if="action.disabled ? !action.disabled(props.row) : true"
              :icon-pack="action.iconPack"
              :icon="action.icon"
              :type="action.type"
              size="is-medium"
              class="cursor-pointer"
            ></b-icon>
          </span>
        </span>
      </b-table-column>

      <!--Details toggle-->
      <b-table-column
        v-if="detailed"
        v-slot="props"
        sort-icon="arrow-up"
        sort-icon-size="is-small"
      >
        <b-icon
          :icon="isVisibleDetailRow(props.row) ? 'chevron-up' : 'chevron-down'"
          class="is-clickable ml-2"
          @click.native="toggle(props.row)"
        ></b-icon>
      </b-table-column>

      <template slot="empty">
        <slot name="empty" />
      </template>

      <template #detail="props">
        <slot name="detail" :row="props.row" />
      </template>
    </b-table>

    <b-pagination
      v-if="paginated"
      :total="total"
      size="20"
      v-model="currentPage"
      @change="onPageChange"
    >
    </b-pagination>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import { SEARCH_FIELD_TYPES } from "@/utils/const";
import dayjs from "dayjs";

export default {
  name: "FieldListing",
  computed: {
    SEARCH_FIELD_TYPES() {
      return SEARCH_FIELD_TYPES;
    },
  },
  props: {
    data: {
      required: true,
    },
    image: {
      default: false,
    },
    imageKey: {
      default: "",
    },
    columns: {
      type: Array,
      required: true,
    },
    customColumns: {
      type: Array,
      request: false,
    },
    actions: {
      type: Array,
      required: false,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    paginated: {
      type: Boolean,
      default: false,
    },
    storeFetchCommand: {
      type: String,
    },
    fetchParam: {
      type: [String, Number],
    },
    storeGetCommand: {
      type: String,
    },
    stickyHeader: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: undefined,
    },
    backendSorting: {
      type: Boolean,
      default: true,
    },
    searchFields: {
      type: Array,
      default: undefined,
    },
    baseQuery: {
      type: String,
      default: undefined,
    },
    detailed: {
      type: Boolean,
      default: false,
    },
    customQueries: {
      type: Array,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fetchFirst: {
      type: Boolean,
      required: false,
      default: false,
    },
    defaultSort: {
      type: String,
      default: undefined,
    },
    defaultSortDirection: {
      type: String,
      default: "desc",
    },
    findPartnerImageUrl: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchInput: "",
      rows: [],
      total: 0,
      currentPage: 1,
      sortField: "",
      sortOrder: "",
      searchObject: {},
      initialSortField: null,
      initialSortOrder: null,
      logoMap: new Map(),
      internalLoading: false,
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(data) {
        this.setData(data);
      },
    },
  },
  created() {
    const sessionSortObject = JSON.parse(
      sessionStorage.getItem("field-listing-sort-object") ?? "{}"
    );
    if (sessionSortObject[this.$route.name]) {
      this.initialSortField = sessionSortObject[this.$route.name].sortField;
      this.initialSortOrder = sessionSortObject[this.$route.name].sortOrder;
    } else {
      this.initialSortField = this.defaultSort;
      this.initialSortOrder = this.defaultSortDirection;
      sessionSortObject[this.$route.name] = {
        sortField: this.defaultSort,
        sortOrder: this.defaultSortDirection,
      };
      sessionStorage.setItem(
        "field-listing-sort-object",
        JSON.stringify(sessionSortObject)
      );
    }
  },
  beforeMount() {
    this.resetSearchObject();
    const sessionSortObject = JSON.parse(
      sessionStorage.getItem("field-listing-sort-object") ?? "{}"
    );
    if (sessionSortObject[this.$route.name]) {
      this.sortField = sessionSortObject[this.$route.name].sortField;
      this.sortOrder = sessionSortObject[this.$route.name].sortOrder;
    }
    this.searchWithComponent();
  },
  mounted() {
    if (this.fetchFirst) {
      this.fetch();
    }
  },
  components: {
    ImageLoader: () => import("@/components/document/ImageLoader.vue"),
  },
  methods: {
    async setData(data) {
      if (Array.isArray(data)) {
        this.rows = this.findPartnerImageUrl
          ? await this.setPartnerImageUrl(data)
          : data;
        this.total = data.length;
      } else {
        this.rows = this.findPartnerImageUrl
          ? await this.setPartnerImageUrl(data.values)
          : data.values;
        this.total = data.total;
      }
    },
    async setPartnerImageUrl(array) {
      for (let element of array) {
        const partnerLogo = element.partnerLogo;
        if (!partnerLogo) continue;

        if (this.logoMap.has(partnerLogo)) {
          element.partnerLogoImageUrl = this.logoMap.get(partnerLogo);
        } else {
          const partnerLogoUrl = await this.createImageUrl(partnerLogo);
          element.partnerLogoImageUrl = partnerLogoUrl;
          this.logoMap.set(partnerLogo, partnerLogoUrl);
        }
      }

      return array;
    },
    async createImageUrl(documentId) {
      try {
        if (!this.$store.getters["drawer/getFile"](documentId)) {
          await this.$store.dispatch("drawer/download", documentId);
        }

        let blob = this.$store.getters["drawer/getFile"](documentId);
        if (blob) {
          return window.URL.createObjectURL(blob);
        }
      } catch (ex) {
        console.error(ex);
      }
      return null;
    },
    getQuery() {
      let pageQuery = this.getPageQuery();
      let searchQuery = this.searchInput
        ? this.getSearchQuery()
        : this.getSearchQueryByComponent();
      let customQuery = this.getCustomQuery();
      let sortQuery = this.getSortQuery();
      return `${pageQuery}${
        searchQuery ? "&" + searchQuery : ""
      }${customQuery}${sortQuery ? "&" + sortQuery : ""}${
        this.baseQuery ? "&" + this.baseQuery : ""
      }`;
    },
    async fetch() {
      let query = this.getQuery().replaceAll("+", "%2b");
      try {
        this.internalLoading = true;
        if (!!this.fetchParam) {
          await this.$store.dispatch(this.storeFetchCommand, {
            fetchParam: this.fetchParam,
            query: query,
          });
        } else {
          await this.$store.dispatch(this.storeFetchCommand, query);
        }
        this.setData(this.$store.getters[this.storeGetCommand]);
      } catch (e) {
        this.$buefy.toast.open({
          message: i18n.t("pp:list.search.message.error"),
          type: "is-danger",
        });
      } finally {
        this.internalLoading = false;
      }
    },
    getPageQuery() {
      return `page=${this.currentPage - 1}`;
    },
    getSortQuery() {
      if (this.sortField) {
        return `sort=${this.sortField},${this.sortOrder}`;
      }
      return undefined;
    },
    getSearchQuery() {
      let searchInput = this.searchInput;
      if (searchInput) {
        if (searchInput.includes("==")) {
          return this.getComplexSearchQuery();
        } else {
          return this.getSimplifiedSearchQuery();
        }
      }
      return undefined;
    },
    getCustomQuery() {
      let searchQuery = "";
      if (this.customQueries) {
        this.customQueries.forEach(
          (query) =>
            (searchQuery = this.appendSearchQuery(
              searchQuery,
              query.identifier,
              query.term
            ))
        );
      }

      return searchQuery;
    },
    getSimplifiedSearchQuery() {
      let searchQuery = "simplifiedSearch=true";
      let searchTerm = this.searchInput.trim().toLowerCase();
      this.searchFields.forEach((searchField) => {
        if (searchField.genericSearch === true) {
          searchQuery = this.addSearchField(
            searchQuery,
            searchField,
            searchTerm
          );
        }
      });
      return searchQuery;
    },
    getComplexSearchQuery() {
      try {
        let searchQuery = "simplifiedSearch=false";
        let conditions = this.searchInput.split("&&");

        if (conditions.length > 0 && conditions[0] !== "") {
          conditions.forEach((element) => {
            let condition = element.split("==");
            let identifier = condition[0].trim();
            let term = condition[1].trim().toLowerCase();

            let searchField = this.searchFields
              .filter((sf) => sf.identifier === identifier)
              .shift();
            if (searchField) {
              searchQuery = this.addSearchField(searchQuery, searchField, term);
            }
          });
        }

        return searchQuery;
      } catch (e) {
        this.$buefy.toast.open({
          message: i18n.t("pp:list.search.message.error"),
          type: "is-danger",
        });
      }
    },
    addSearchField(searchQuery, searchField, searchTerm) {
      if (searchField.type === SEARCH_FIELD_TYPES.TEXT) {
        searchQuery = this.appendSearchQuery(
          searchQuery,
          searchField.identifier,
          searchTerm
        );
      }
      if (searchField.type === SEARCH_FIELD_TYPES.INTEGER) {
        if (!isNaN(searchTerm) && searchTerm.length <= 10) {
          searchQuery = this.appendSearchQuery(
            searchQuery,
            searchField.identifier,
            searchTerm
          );
        }
      }
      if (searchField.type === SEARCH_FIELD_TYPES.LONG) {
        if (!isNaN(searchTerm)) {
          searchQuery = this.appendSearchQuery(
            searchQuery,
            searchField.identifier,
            searchTerm
          );
        }
      }
      if (searchField.type === SEARCH_FIELD_TYPES.ENUM) {
        Object.entries(searchField.values).forEach((entry) => {
          const [key, value] = entry;
          if (i18n.t(value).toLowerCase().includes(searchTerm)) {
            searchQuery = this.appendSearchQuery(
              searchQuery,
              searchField.identifier,
              key
            );
          }
        });
      }
      if (searchField.type === SEARCH_FIELD_TYPES.BOOLEAN) {
        ["igen", "true"].forEach((value) => {
          if (value === searchTerm) {
            searchQuery = this.appendSearchQuery(
              searchQuery,
              searchField.identifier,
              true
            );
          }
        });
        ["nem", "false"].forEach((value) => {
          if (value === searchTerm) {
            searchQuery = this.appendSearchQuery(
              searchQuery,
              searchField.identifier,
              false
            );
          }
        });
      }
      if (searchField.type === SEARCH_FIELD_TYPES.DATE) {
        let date = new Date(searchTerm);
        if (date != "Invalid Date" && searchTerm.length >= 10) {
          searchQuery = this.appendSearchQuery(
            searchQuery,
            searchField.identifier,
            dayjs(new Date(date.toUTCString().substr(0, 25))).format(
              "YYYY-MM-DD"
            )
          );
        }
      }
      if (searchField.type === SEARCH_FIELD_TYPES.DATETIME) {
        let date = new Date(searchTerm);
        if (date != "Invalid Date" && searchTerm.length >= 10) {
          searchQuery = this.appendSearchQuery(
            searchQuery,
            searchField.identifier,
            dayjs(new Date(date.toUTCString().substr(0, 25)))
              .format("YYYY-MM-DDTHH:mm:ss")
              .concat("Z")
          );
        }
      }
      return searchQuery;
    },
    appendSearchQuery(query, identifier, term) {
      return query.concat("&").concat(identifier).concat("=").concat(term);
    },
    async onSort(field, order) {
      if (this.backendSorting) {
        const sessionSortObject = JSON.parse(
          sessionStorage.getItem("field-listing-sort-object") ?? "{}"
        );
        sessionSortObject[this.$route.name] = {
          sortField: field,
          sortOrder: order,
        };
        sessionStorage.setItem(
          "field-listing-sort-object",
          JSON.stringify(sessionSortObject)
        );
        this.sortField = field;
        this.sortOrder = order;
        await this.fetch();
      }
    },
    async onPageChange() {
      await this.fetch();
    },
    async search() {
      await this.fetch();
    },
    isVisibleDetailRow(row) {
      return this.$refs.table.isVisibleDetailRow(row);
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    },
    getSearchQueryByComponent() {
      let searchQuery = "simplifiedSearch=false";
      if (Object.keys(this.searchObject).length > 0) {
        for (let searchFieldIdentifier of Object.keys(this.searchObject)) {
          let searchField = this.searchFields.find(
            (sF) => sF.identifier === searchFieldIdentifier
          );
          let searchTerm = this.searchObject[searchFieldIdentifier];
          if (
            searchField.type === SEARCH_FIELD_TYPES.ENUM &&
            searchTerm.length
          ) {
            searchTerm.forEach((entry) => {
              searchQuery = this.appendSearchQuery(
                searchQuery,
                searchField.identifier,
                entry
              );
            });
          } else if (
            searchField.type === SEARCH_FIELD_TYPES.DATE ||
            searchField.type === SEARCH_FIELD_TYPES.DATETIME
          ) {
            if (searchTerm[0] !== null) {
              let date = new Date(searchTerm[0]);
              searchQuery = this.appendSearchQuery(
                searchQuery,
                searchField.identifier,
                dayjs(date).format("YYYY-MM-DDTHH:mm:ss").concat("Z")
              );
            }
            if (searchTerm[1] !== null) {
              let date = new Date(searchTerm[1]);
              if (searchField.type === SEARCH_FIELD_TYPES.DATE) {
                date.setHours(23, 59, 59);
              }
              searchQuery = this.appendSearchQuery(
                searchQuery,
                searchField.identifier,
                dayjs(date).format("YYYY-MM-DDTHH:mm:ss").concat("Z")
              );
            }
          } else if (this.searchObject[searchFieldIdentifier] !== null) {
            if (searchField.type === SEARCH_FIELD_TYPES.TEXT) {
              if (searchTerm.includes(",")) {
                searchTerm.split(",").forEach((sT) => {
                  searchQuery = this.appendSearchQuery(
                    searchQuery,
                    searchField.identifier,
                    sT
                  );
                });
              } else {
                searchQuery = this.appendSearchQuery(
                  searchQuery,
                  searchField.identifier,
                  searchTerm
                );
              }
            }
            if (searchField.type === SEARCH_FIELD_TYPES.INTEGER) {
              if (searchTerm.includes(",")) {
                searchTerm.split(",").forEach((sT) => {
                  if (!isNaN(sT) && sT.length <= 10) {
                    searchQuery = this.appendSearchQuery(
                      searchQuery,
                      searchField.identifier,
                      sT
                    );
                  }
                });
              } else {
                if (!isNaN(searchTerm) && searchTerm.length <= 10) {
                  searchQuery = this.appendSearchQuery(
                    searchQuery,
                    searchField.identifier,
                    searchTerm
                  );
                }
              }
            }
            if (searchField.type === SEARCH_FIELD_TYPES.LONG) {
              if (searchTerm.includes(",")) {
                searchTerm.split(",").forEach((sT) => {
                  if (!isNaN(sT)) {
                    searchQuery = this.appendSearchQuery(
                      searchQuery,
                      searchField.identifier,
                      sT
                    );
                  }
                });
              } else {
                if (!isNaN(searchTerm)) {
                  searchQuery = this.appendSearchQuery(
                    searchQuery,
                    searchField.identifier,
                    searchTerm
                  );
                }
              }
            }
            if (searchField.type === SEARCH_FIELD_TYPES.BOOLEAN) {
              searchQuery = this.appendSearchQuery(
                searchQuery,
                searchField.identifier,
                searchTerm
              );
            }
          }
        }
      }
      return searchQuery;
    },
    resetSearchObject(empty = false) {
      const previousSearchObject = JSON.parse(
        sessionStorage.getItem("field-listing-search-object") ?? "{}"
      )[this.$route.name];
      for (let field of this.searchFields) {
        if (
          empty === false &&
          previousSearchObject &&
          previousSearchObject[field.identifier]
        ) {
          this.$set(
            this.searchObject,
            field.identifier,
            previousSearchObject[field.identifier]
          );
        } else {
          if (field.type === SEARCH_FIELD_TYPES.ENUM) {
            this.$set(this.searchObject, field.identifier, []);
          } else if (
            field.type === SEARCH_FIELD_TYPES.DATE ||
            field.type === SEARCH_FIELD_TYPES.DATETIME
          ) {
            this.$set(this.searchObject, field.identifier, [null, null]);
          } else {
            this.$set(this.searchObject, field.identifier, null);
          }
        }

        if (typeof field.defaultValue !== "undefined" && !empty) {
          if (
            field.type === SEARCH_FIELD_TYPES.DATE ||
            field.type === SEARCH_FIELD_TYPES.DATETIME
          ) {
            const [from, to] = (field.defaultValue || "").split(";");
            this.$set(this.searchObject, field.identifier, [
              from ? new Date(from) : null,
              to ? new Date(to) : null,
            ]);
          } else {
            this.$set(this.searchObject, field.identifier, field.defaultValue);
          }
        }
      }
    },
    async searchWithComponent() {
      const sessionSearchObject = JSON.parse(
        sessionStorage.getItem("field-listing-search-object") ?? "{}"
      );
      sessionSearchObject[this.$route.name] = this.searchObject;
      sessionStorage.setItem(
        "field-listing-search-object",
        JSON.stringify(sessionSearchObject)
      );
      let query = this.getQuery().replaceAll("+", "%2b");
      try {
        this.internalLoading = true;
        if (!!this.fetchParam) {
          await this.$store.dispatch(this.storeFetchCommand, {
            fetchParam: this.fetchParam,
            query: query,
          });
        } else {
          await this.$store.dispatch(this.storeFetchCommand, query);
        }
        this.setData(this.$store.getters[this.storeGetCommand]);
      } catch (e) {
        this.$buefy.toast.open({
          message: i18n.t("pp:list.search.message.error"),
          type: "is-danger",
        });
      } finally {
        this.internalLoading = false;
      }
    },
    deleteSearchValue(id, index = null) {
      if (index || index === 0) {
        this.$set(this.searchObject[id], index, null);
      } else {
        this.$set(this.searchObject, id, null);
      }
    },
  },
};
</script>

<style scoped>
.mp-search-input-wrapper {
  width: 30%;
}

.mp-search-input {
  width: 100%;
}

.search-tooltip-icon {
  cursor: pointer;
  margin-top: 0.5rem;
  margin-right: 0.75rem;
}
</style>

<style>
.b-table table th:last-child,
.b-table table td:last-child {
  position: sticky;
  right: 0;
  left: auto !important;
  z-index: 2;
  background: white;
}

.b-table table tr:hover td:last-child {
  background: inherit;
}

.tooltip-content {
  margin-left: 10rem;
}

.search-toggles {
  flex: 1;
  margin-left: 1rem;
  margin-bottom: 0.5rem;
}

.searchComponent .label {
  font-size: 0.75rem;
}

.searchComponent input {
  font-size: 0.75rem;
}

.search-component-info .tooltip-content {
  margin-left: 0;
}
</style>
